import * as React from 'react';
import { observer } from 'mobx-react';
import AnsweredQuestionnaire from '../../components/questionnaire/answeredQuestionnaire/AnsweredQuestionnaire';
import { getAnsweredQuestionnaireById } from '../assessment/questionnaireApi';
import NotFoundPage from '../error/NotFoundPage';
import { withAnsweredQuestionnaire } from '../../router/Loaders';

interface Props {
  questionnaireId: number;
  renderSearch: (showSearch: boolean) => void;
  enableComment: boolean
}

@observer
class Evaluation extends React.Component<Props, {}> {

  constructor(props: Props) {
    super(props);
    this.props.renderSearch(false);
  }

  public render() {
    return (
      <>
        {
          withAnsweredQuestionnaire(
            () => getAnsweredQuestionnaireById(this.props.questionnaireId),
            answeredQuestionnaire =>
              <AnsweredQuestionnaire
                enableComment={this.props.enableComment}
                questionnaireId={this.props.questionnaireId}
                answeredQuestionnaire={answeredQuestionnaire} errorPage={<NotFoundPage/>}/>
          )
        }
      </>
    );
  }
}

export default Evaluation;
